import React from 'react';
import dateFormat from 'dateformat';
import { markupHelpers } from '../../../helpers/index';
import * as Buttons from '../../ui/buttons';
import { getFullMonthYear } from './../../../../../../../helpers/common/date-util';

export const AwardItem = props => {
	const { name, issuer, description, date, buttonHandlers, guestMode } = props;
	const convertedName = markupHelpers.escapeHtmlHelper(name),
		convertedIssuer = markupHelpers.escapeHtmlHelper(issuer),
		convertedDescription = markupHelpers.escapeHtmlHelper(description);
	return (
		<div className="item-achievements awards">
			{/*show when not in guestMode*/}
			{!guestMode && (
				<div className="item-display-mode">
					<Buttons.EditButton {...buttonHandlers} />
				</div>
			)}
			{/*/////////*/}
			<div className="row">
				<div className="col-4 col-lg-3 new-profile-label">Name</div>
				<div
					className="col-8 col-lg-9 new-profile-info item-header"
					dangerouslySetInnerHTML={{ __html: convertedName }}
				/>
			</div>
			{issuer && (
				<div className="row">
					<div className="col-4 col-lg-3 new-profile-label">Issuer</div>
					<div
						className="col-8 col-lg-9 new-profile-info"
						dangerouslySetInnerHTML={{ __html: convertedIssuer }}
					/>
				</div>
			)}
			<div className="row">
				<div className="col-4 col-lg-3 new-profile-label">Date</div>
				<div className="col-8 col-lg-9 new-profile-info">
					{ getFullMonthYear( date ) }
				</div>
			</div>
			{!description || description === 'null' ? null : (
				<div className="row">
					<div className="col-4 col-lg-3 new-profile-label">Description</div>
					<div
						className="col-8 col-lg-9 new-profile-info editor"
						dangerouslySetInnerHTML={{ __html: convertedDescription }}
					/>
				</div>
			)}
		</div>
	);
};



// WEBPACK FOOTER //
// src/client/components/site/features/profile/elements/body/achievements/AwardItem.js